export default {
  STORE_TOKEN (state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  AUTH_SUCCESS (state) {
    state.isLoggedIn = true
  },
  LOGOUT (state) {
    state.isLoggedIn = false
    state.token = false
    localStorage.removeItem('token')
  },
  REFRESH_TOKEN_PENDING (state, status) {
    state.refreshTokenPending = status
  },
  STORE_NEW_TOKEN (state, token) {
    state.lastToken = state.token
    state.token = token
    localStorage.setItem('token', token)
    setTimeout(() => {
      state.refreshTokenPending = false
    }, 5000)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js